export class ClientInformation {
    clientInformationId?: string;
    clientFullName?: string;
    clientShortName?: string;
    clientDisplayName: string;
    clientAbbreviatedName: string;
    compensafeInternalName: string;
    deleted?: boolean;
    uiDisplay?: boolean;
    dataSourceTypeAgg: string;
    losTalkerClientId?: number;
    parentCompany?: string;
    clientInformationAliases?: string;
    integrationCount?: number;

    constructor(c?: ClientInformation){
        this.clientInformationId = c?.clientInformationId;
        this.clientFullName = c?.clientFullName;
        this.clientShortName = c?.clientShortName;
        this.clientDisplayName = c?.clientDisplayName;
        this.clientAbbreviatedName = c?.clientAbbreviatedName;
        this.compensafeInternalName = c?.compensafeInternalName;
        this.deleted = c?.deleted;
        this.uiDisplay = c?.uiDisplay;
        this.dataSourceTypeAgg = c?.dataSourceTypeAgg;
        this.losTalkerClientId = c?.losTalkerClientId;
        this.parentCompany = c?.parentCompany;
        this.clientInformationAliases = c?.clientInformationAliases;
        this.integrationCount = c?.integrationCount;
    }
}